/* global gtag */
export async function gtag_report_conversion(url, hashedPhoneNumber = "") {
  return new Promise((resolve) => {
    try {
      if (process.env.NODE_ENV === "development") {
        resolve(false); // Skip conversion tracking in development
        return;
      }

      // Set up timeout as fallback
      const timeout = setTimeout(() => {
        resolve(false);
      }, 2000); // 2 second timeout

      var callback = function () {
        clearTimeout(timeout);
        if (typeof url != "undefined") {
          window.location = url;
        }
        resolve(true);
      };

      gtag("event", "conversion", {
        send_to: "AW-943975065/wr8fCPmDlbYbEJnVj8ID",
        value: 1.0,
        currency: "USD",
        event_callback: callback,
        // user_data: {
        //   phone_number: hashedPhoneNumber,
        // },
      });
    } catch (err) {
      console.error("Error reporting conversion:", err);
      resolve(false);
    }
  });
}
